export default __webpack_public_path__ + "static/media/Ystad_full.01bb8806.png";